import React from 'react'
import { RepoIcon } from '@primer/octicons-react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { dasherize } from '@/utilities'

const OtherCandidates = ({ distrito, lista, nombre }) => {
  const data = useStaticQuery(graphql`
    query {
      allGoogleSheetCandidatosConvencionConstituyenteRow(
        filter: { candidaturaconfirmadaalultimoboletin: { ne: "No" } }
      ) {
        nodes {
          id
          nombre
          nombrenomina
          distrito
          lista
          escanoreservadosino
          pueblooriginariosicorresponde
        }
      }
    }
  `)

  const constituyentesPorDistrito = groupBy(
    data.allGoogleSheetCandidatosConvencionConstituyenteRow.nodes,
    'distrito',
  )

  const otrosConstituyentes = constituyentesPorDistrito[distrito]
    .filter(constituyente => constituyente.lista === lista)
    .filter(constituyente => constituyente.nombre !== nombre)

  // console.log('otrosConstituyentes', otrosConstituyentes)
  return (
    <div>
      {otrosConstituyentes && otrosConstituyentes.length > 0 ? (
        <>
          {otrosConstituyentes.map(constituyente => {
            const link = `/distrito-${
              constituyente.distrito === 999
                ? 'pueblos-originarios'
                : constituyente.distrito
            }/${dasherize(constituyente.nombre)}/`
            return (
              <h4
                className="px-2 py-4 border-gray-300 sm:py-2 border-b-default hover:bg-gray-300 "
                key={constituyente.nombre}>
                <Link className="underline" to={link}>
                  {constituyente.nombrenomina}
                </Link>
              </h4>
            )
          })}
        </>
      ) : (
        <h4>No existen más candidatos para esta lista.</h4>
      )}
    </div>
  )
}

const groupBy = (list, props) => {
  return list.reduce((a, b) => {
    ;(a[b[props]] = a[b[props]] || []).push(b)
    return a
  }, {})
}

export default OtherCandidates
